import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ChevronIcon } from '@/components/UI/Icons/Icons';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

export const Container = styled.div`
  padding: 0 40px;

  @media (max-width: 743px) {
    padding: 0 15px;
  }
`;

export const CategoryItems = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => `${$gap ?? 10}px`};
  padding: 5px 40px;

  @media (max-width: 743px) {
    padding: 5px 15px;
  }
`;

export const CategoryItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 15px;
  min-height: 45px;
  width: 100%;
  padding-right: 15px;
  background: ${({ theme }) => theme.palette.primary.background};
  user-select: none;
  border-radius: 14px;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: ${({ theme }) => theme.palette.secondary.background};
      color: ${({ theme }) => theme.palette.brand.main};

      & svg {
        color: ${({ theme }) => theme.palette.brand.main};
      }
    `}

  img {
    object-fit: contain;
  }
`;

export const CategoryItemIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const CategoryLabel = styled(Typography.Text)`
  font-size: 15px;
  width: 100%;
`;

export const CategoryChevronIcon = styled(ChevronIcon)`
  width: 35px;
  height: 35px;
  transform: rotate(180deg);
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const SubcategoryFilteredItem = styled(Checkbox)`
  user-select: none;
  min-height: 45px;
  height: 45px;
`;

export const SubcategoryCustomContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  img {
    object-fit: contain;
  }
`;

export const SubcategoryCustomInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 5px;
`;
